<style src="../node_modules/buefy/dist/buefy.min.css"></style>

<style src="./css/main.min.css"></style>
<style src="./css/themeone.min.css"></style>
<!-- <style src="./css/themetwo.min.css"></style> -->
<style src="./css/responsive.min.css"></style>
<style>
/* @import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.8.2/css/all.min.css"); */
</style>

<template>
  <div id="app">
    <div id="myContainer" ref="myContainerRef"></div>
    <router-view></router-view>
  </div>
</template>

<script>
import Vue from "vue";
import store from "./store";
import { getRouter } from "./router";
let router = getRouter({ store });
import axiosPlugin from "./plugins/axios";
import utilsPlugin from "./plugins/utils";
import io from "socket.io-client";

/* import the fontawesome core */
import { library } from "@fortawesome/fontawesome-svg-core";

/* import specific icons */
import {
  faHouse,
  faUser,
  faCartShopping,
  faClose,
  faCircleCheck,
  faWallet,
  faCircleXmark,
  faGear,
  faCoins,
  faBell,
  faRightFromBracket,
  faShuffle,
  faPencil,
  faTrash,
  faSearch,
  faEye,
  faAngleLeft,
  faAngleRight,
  faEyeSlash,
  faCopy,
  faPlus,
  faTimes,
  faAngleDown,
  faMinus,
  faCamera,
  faSmile,
  faPlane,
  faHome,
  faStar,
  faBolt,
} from "@fortawesome/free-solid-svg-icons";

import { faEnvelope } from "@fortawesome/free-regular-svg-icons";

import { faFacebookF, faGoogle } from "@fortawesome/free-brands-svg-icons";

/* import font awesome icon component */
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faHouse,
  faUser,
  faCartShopping,
  faGear,
  faWallet,
  faCoins,
  faBell,
  faRightFromBracket,
  faShuffle,
  faPencil,
  faClose,
  faCircleCheck,
  faCircleXmark,
  faTrash,
  faSearch,
  faEye,
  faAngleLeft,
  faAngleRight,
  faAngleDown,
  faEyeSlash,
  faCopy,
  faPlus,
  faMinus,
  faEnvelope,
  faFacebookF,
  faTimes,
  faGoogle,
  faCamera,
  faSmile,
  faPlane,
  faHome,
  faStar,
  faEye,
  faBolt
);

/* add font awesome icon component */
Vue.component("font-awesome-icon", FontAwesomeIcon);

import Buefy, { ConfigProgrammatic } from "../buefy";
import {
  Table,
  Input,
  Modal,
  Button,
  Autocomplete,
  Field,
  Dialog,
  Snackbar,
  Tabs,
  Datepicker,
} from "../buefy";

Vue.use(Buefy, {
  defaultIconComponent: "font-awesome-icon",
  defaultIconPack: "fas",
});

ConfigProgrammatic.setOptions({
  defaultIconPack: "fas",
  defaultIconComponent: "font-awesome-icon",
});

import { i18n, getBrowserLocale } from "./i18n";

Vue.use(axiosPlugin, { router, store, i18n });
Vue.use(utilsPlugin, { router, store, i18n });

Vue.use(Table);
Vue.use(Input);
Vue.use(Button);
Vue.use(Autocomplete);
Vue.use(Field);
Vue.use(Dialog);
Vue.use(Snackbar);
Vue.use(Tabs);

Vue.use(Modal);
Vue.use(Datepicker);
Vue.prototype.strLottoId = "";

import { mapGetters } from "vuex";

import "./vee-validate";
export default {
  name: "app",

  data() {
    return {
      socket: null,
    };
  },

  props: {
    cid: {
      type: String,
      default: "DM",
    },

    bid: {
      type: String,
      default: "DM",
    },
    mode: {
      type: String,
      default: "",
    },
    lang: {
      type: String,
      // Default to the browser's language (falling back to "en"); an explicit
      // `lang` prop (e.g. widget embedding) still takes precedence.
      default: () => getBrowserLocale(),
    },
  },
  i18n,
  router,
  store,
  computed: {
    ...mapGetters([
      "blnIsUserLoggedIn",
      "strToken",
      "arrLottoConfigs",
      "objWalletStats",
      "objUser",
      "objUserProfile",
    ]),
  },
  created() {
    this.$i18n.locale = this.lang;

    const strDeepLinkLottoId = new URLSearchParams(window.location.search).get("lotto_id");
    if (strDeepLinkLottoId) {
      this.$router
        .replace({ name: "PickNumbers", query: { strLottoId: strDeepLinkLottoId } })
        .catch(() => {});
    }

    this.setLottos();
  },
  beforeDestroy() {
    // Disconnect WebSocket on destroy
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
    // Stop the cart-expiry sweep timer
    if (this.objExpiryTimer) {
      clearInterval(this.objExpiryTimer);
      this.objExpiryTimer = null;
    }
  },
  async mounted() {
    // router.push("/home");

    // Reset loading state on mount (may be stuck from persisted state)
    this.$store.state.blnLoading = false;

    this.$store.commit("wipeExpiredBets");
    this.objExpiryTimer = setInterval(() => {
      this.$store.commit("wipeExpiredBets");
    }, 30000);

    const urlParams = new URLSearchParams(window.location.search);
    const strPlayerToken = urlParams.get("player_token");
    const strClientId = urlParams.get("client_id");
    const strBrandingId = urlParams.get("b");
    const strLottoId = urlParams.get("lotto_id");

    // Detect widget mode (3rd party integration via player_token)
    const blnWidgetMode = !!strPlayerToken;
    Vue.prototype.$blnWidgetMode = blnWidgetMode;

    // Store deep link lotto ID for navigation after load
    Vue.prototype.$strDeepLinkLottoId = strLottoId;

    // Use client_id from URL if available (widget mode), otherwise use prop
    Vue.prototype.$strClientId = strClientId || this.cid;
    Vue.prototype.$strBrandingId = strBrandingId || this.bid;

    Vue.prototype.$strMode = this.mode;

    if (blnWidgetMode) {
      // 3rd party widget mode - authenticate via player token
      await this.authenticateWithPlayerToken(strPlayerToken, strClientId);
    } else {
      let strLoginToken = localStorage.getItem("t");

      // Dev fallback - only use if no stored token. Provide a token via a
      // gitignored .env.local (VUE_APP_DEV_LOGIN_TOKEN) so no secret lives in source.
      if (!strLoginToken && process.env.NODE_ENV !== "production") {
        strLoginToken = process.env.VUE_APP_DEV_LOGIN_TOKEN || null;
      }

      if (strLoginToken) {
        this.setAxiosToken(strLoginToken);
        this.ping();
        // Connect to WebSocket for real-time updates
        this.connectToWebSocket(strLoginToken);
      }
    }

    Vue.prototype.$root = this.$root;

    // Only emit state here for non-widget mode (widget mode emits after auth)
    if (!blnWidgetMode) {
      this.$store.commit("emitState");
    }

    await this.load();
  },
  methods: {
    async authenticateWithPlayerToken(strPlayerToken, strClientId) {
      try {
        const objResponse = await this.$myAxios.post("/w/token-auth", {
          player_token: strPlayerToken,
          client_id: strClientId,
        });

        if (objResponse.blnOK) {
          const { strToken, objUser, intBalance, strCurrency } = objResponse;

          this.setAxiosToken(strToken);

          // Store external user ID for balance lookups
          if (objUser.ext_user_id) {
            Vue.prototype.$strExtUserId = objUser.ext_user_id;
          }

          // Start batch update to avoid multiple emitState calls
          this.$store.commit("startBatchUpdate");

          // Sign in the user
          this.$store.commit("signIn", {
            objUser,
            strToken,
          });

          // Also set user profile for UI display (name, etc. from 3rd party)
          this.$store.commit("setUserProfile", objUser);

          // Set initial balance (from 3rd party)
          if (intBalance !== undefined) {
            this.$store.commit("setWalletStats", {
              fltEffectiveBalance: intBalance,
              strCurrency: strCurrency || "USD",
            });
          }

          // End batch update - emits state once
          this.$store.commit("endBatchUpdate");

          // Notify parent window (if in iframe)
          this.notifyParentWindow("authenticated", {
            user: objUser,
            balance: intBalance,
          });

          // Connect to WebSocket for real-time balance updates
          this.connectToWebSocket(strToken);
        } else {
          console.error("[Widget] Authentication failed:", objResponse.strMessage);
          this.notifyParentWindow("authFailed", {
            error: objResponse.strMessage,
          });
        }
      } catch (error) {
        console.error("[Widget] Authentication error:", error);
        this.notifyParentWindow("authFailed", {
          error: error.message,
        });
      }
    },

    /**
     * Send message to parent window (for iframe communication)
     */
    notifyParentWindow(type, data) {
      if (window.parent && window.parent !== window) {
        window.parent.postMessage({ type, ...data }, "*");
      }
    },

    /**
     * Connect to WebSocket server for real-time updates
     */
    connectToWebSocket(strToken) {
      // WebSocket server URL - use environment variable or default to localhost
      const wsUrl = process.env.VUE_APP_WS_URL || "http://localhost:3001";

      this.socket = io(wsUrl, {
        auth: {
          token: strToken,
        },
        transports: ["websocket", "polling"],
      });

      this.socket.on("connect", () => {});

      this.socket.on("disconnect", () => {});

      // Listen for balance updates
      this.socket.on("bal", (data) => {
        if (data.fltBalance !== undefined) {
          this.$store.commit("setWalletStats", {
            fltEffectiveBalance: data.fltBalance,
          });

          // Notify parent window of balance change
          this.notifyParentWindow("balanceUpdate", {
            balance: data.fltBalance,
          });
        }
      });

      // Listen for events
      this.socket.on("e", (data) => {
        if (data.objEvent) {
          // Handle specific events (e.g., bet won, draw completed)
          this.notifyParentWindow("event", data.objEvent);
        }
      });

      this.socket.on("connect_error", (error) => {
        console.error("[Widget] WebSocket connection error:", error.message);
      });
    },

    async loadWalletStats() {},
    async loadUserInfo() {
      let p1 = this.$myAxios.get("/u/wallet-stats");
      let p2 = this.$myAxios.get("/u/me");
      let arr = await Promise.all([p1, p2]);

      //console.log(arr);

      let objResponse1 = arr[0];
      let objResponse2 = arr[1];

      if (objResponse1.blnOK) {
        let objWalletStats = objResponse1.obj;
        //console.log("Setting wallet stats");

        this.$store.commit("setWalletStats", objWalletStats);
      } else {
        //console.log(objResponse1.strMessage);
      }

      if (objResponse2.blnOK) {
        let objUser = objResponse2.obj;
        //console.log("Setting user profile");
        this.$store.commit("setUserProfile", objUser);
      } else {
        //console.log(objResponse2.strMessage);
      }
    },
    async emitUserInfo() {
      // Skip in widget mode - balance comes from 3rd party API
      if (Vue.prototype.$blnWidgetMode) {
        return;
      }

      let strLoginToken = localStorage.getItem("t");
      if (!strLoginToken) {
        // console.log("user not logged in");
        return;
      }

      try {
        await this.loadUserInfo();
      } catch (e) {
        console.log(e);
      }

      let strBalance = "";
      let strPendingWithdrwal = "";
      let strMobile = "";
      let strAvatarUrl = "";

      if (this.objUserProfile) {
        strMobile = this.objUserProfile.mobile;
        strAvatarUrl = this.$utils.getAvatarFileName(this.objUserProfile);
      }

      if (this.objWalletStats) {
        strBalance = this.objWalletStats.fltEffectiveBalance;
      }

      let objUserInfo = {
        strBalance,
        strMobile,
        strPendingWithdrwal,
        strAvatarUrl,
      };

      //console.log(objUserInfo);

      this.$utils.emitWCEvent2(this, "userInfo", objUserInfo);
    },

    async load() {
      // Only sign in with test user if not already authenticated (e.g., via player_token)
      if (!this.blnIsUserLoggedIn) {
        this.$store.commit("signIn", {
          objUser: { first_name: "test", last_name: "lastname" },
          strToken: "",
        });
      }

      this.emitUserInfo();
      let arr = [this.loadLottosConfigs(), this.loadSettings()];

      let arrResponses = await Promise.all(arr);

      let objConfigResponse = arrResponses[0];
      let objSettingsResponse = arrResponses[1];

      if (objConfigResponse.blnOK) {
        let arr = objConfigResponse.arr;
        for (let obj of arr) {
          obj.strCountdown = "xx";
        }

        arr = this.sortLottos(arr);

        this.$store.commit("setLottoConfigs", arr);


        let objStyle = {};
        if (objConfigResponse.arr && objConfigResponse.arr.length > 0) {
          const lottoConfig = objConfigResponse.arr[0];

          if (lottoConfig.strStyleJSON) {
            try {
              objStyle = JSON.parse(lottoConfig.strStyleJSON);
            } catch (e) {
              console.error("Error parsing style_json:", e);
            }
          }
        }
        this.$store.commit("applyLottoStyle", objStyle);

        const strDeepLinkLottoId = Vue.prototype.$strDeepLinkLottoId;
        if (strDeepLinkLottoId && !arr.find(l => l.strLottoId === strDeepLinkLottoId)) {
          this.$router.replace({ name: "Home" }).catch(() => {});
        }
      }

      if (objSettingsResponse.blnOK) {
        let { obj } = objSettingsResponse;
        this.$store.commit("setBrandingSettings", obj);
      }
    },
    sortLottos(arrLottos) {
      // Sort by name alphabetically
      return arrLottos.sort((a, b) => {
        const nameA = (a.strName || "").toLowerCase();
        const nameB = (b.strName || "").toLowerCase();
        return nameA.localeCompare(nameB);
      });
    },
    setLottos() {
      // Initialize with empty array - lottos will be loaded from API in load()
      this.$store.commit("setLottos", []);
    },

    async loadLottosConfigs() {
      let objRequest = {};
      return this.$myAxios.post("/lottos-configs", objRequest);
    },

    async loadSettings() {
      return this.$myAxios.get("/lb-settings");
    },

    async ping() {
      try {
        let objResponse = await this.$myAxios.get("/u/ping");
        if (!objResponse.blnOK) {
          this.$store.commit("logout");
          this.$utils.emitWCEvent(this, "signIn");
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
